import { useGetList } from "ra-core";
import type { Identifier } from "ra-core";
import type { BCInteractionLog, ContactNote } from "../types";

export type TimelineItem =
  | { type: "note"; data: ContactNote }
  | { type: "bc_interaction"; data: BCInteractionLog };

export function useContactTimeline(contactId: Identifier) {
  const {
    data: notes = [],
    isPending: notesPending,
    refetch,
  } = useGetList<ContactNote>("contact_notes", {
    filter: { contact_id: contactId },
    sort: { field: "date", order: "DESC" },
    pagination: { page: 1, perPage: 50 },
  });

  const { data: interactions = [], isPending: interactionsPending } =
    useGetList<BCInteractionLog>("bc_interaction_log", {
      filter: { contact_id: contactId },
      sort: { field: "interaction_date", order: "DESC" },
      pagination: { page: 1, perPage: 100 },
    });

  const combined: TimelineItem[] = [
    ...notes.map((n) => ({ type: "note" as const, data: n })),
    ...interactions.map((i) => ({ type: "bc_interaction" as const, data: i })),
  ].sort((a, b) => {
    const dateA = a.type === "note" ? a.data.date : a.data.interaction_date;
    const dateB = b.type === "note" ? b.data.date : b.data.interaction_date;
    return new Date(dateB).getTime() - new Date(dateA).getTime();
  });

  return {
    data: combined,
    notes,
    isPending: notesPending || interactionsPending,
    refetch,
  };
}
